var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 763.44 763.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentcolor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.83,559.09A200.24,200.24,0,0,1,282,556L151.65,686.32A381.72,381.72,0,0,0,606.78,690Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.48,481.44a199.62,199.62,0,0,1-26.61-99.72c0-110.75,90.1-200.85,200.85-200.85a199.62,199.62,0,0,1,99.72,26.61L611.79,77.13A379.93,379.93,0,0,0,381.72,0C170.9,0,0,170.9,0,381.72A380,380,0,0,0,77.13,611.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.32,151.65,556,282a200.23,200.23,0,0,1-3.24,204.92L682.53,616.74a381.76,381.76,0,0,0,3.79-465.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 381.72,
    cy: 381.72,
    r: 95.46
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.e929a132.svg";
export { ForwardRef as ReactComponent };